import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const EQUIPMENT_PER_STOCK_LOCATIONS_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator(
	'EQUIPMENT_PER_STOCK_LOCATIONS'
);
export const EQUIPMENT_PER_STOCK_LOCATIONS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	EQUIPMENT_PER_STOCK_LOCATIONS_CRUD_ACTION_CONSTANTS
);
